/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import React from "react";

import { escapeHTML } from "lib/escapeHTML";

export default class AppError extends React.Component {

   public render(): React.ReactNode {

      const query = new URLSearchParams(window.location.search);
      const message = escapeHTML(query.get("message"));

      return (
         <div>
            <h1>Fatal error!</h1>
            <h4>{message}</h4>
            <p>Please contact administrator</p>
         </div>
      );

   }

}